const STORAGE_KEY = "sp.lab.messageRevisions.v1";

export function emptyRevisions() {
  return { overrides: {}, promptOverrides: {}, integrations: [], comments: {} };
}

const SUIVI_KEYS = [
  "ask",
  "later",
  "already",
  "activities",
  "duration",
  "difficulty",
  "blockage",
  "adapt",
  "adapted",
  "keep",
  "nudge",
];

function moveSuiviKeys(map) {
  const next = { ...(map || {}) };
  let changed = false;
  SUIVI_KEYS.forEach((suffix) => {
    const from = `f4.${suffix}`;
    const to = `f6.${suffix}`;
    if (typeof next[from] === "string" && typeof next[to] !== "string") {
      next[to] = next[from];
      delete next[from];
      changed = true;
    }
  });
  return { next, changed };
}

function migrateSuiviKeys(state) {
  const movedOverrides = moveSuiviKeys(state.overrides);
  const movedPrompts = moveSuiviKeys(state.promptOverrides);
  let changed = movedOverrides.changed || movedPrompts.changed;
  const integrations = (state.integrations || []).map((item) => {
    const suffix = typeof item.key === "string" ? item.key.slice(3) : "";
    if (item.key && item.key.startsWith("f4.") && SUIVI_KEYS.includes(suffix)) {
      changed = true;
      return { ...item, key: `f6.${suffix}`, flowId: 6 };
    }
    return item;
  });
  const next = {
    overrides: movedOverrides.next,
    promptOverrides: movedPrompts.next,
    integrations,
    comments: state.comments && typeof state.comments === "object" ? state.comments : {},
  };
  if (changed) saveRevisions(next);
  return next;
}

/** Editors show these fields instead of names, so saved texts stay personalized. */
export const FIELD_CTX = { studentName: "{student}", child: "{enfant}", parentName: "{parent}", tutorName: "{tuteur}" };

export function loadRevisions() {
  try {
    if (typeof localStorage === "undefined") return emptyRevisions();
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return emptyRevisions();
    const parsed = JSON.parse(raw.replaceAll("te proposerons", "te proposeront"));
    return migrateSuiviKeys({
      overrides:
        parsed?.overrides && typeof parsed.overrides === "object"
          ? Object.fromEntries(Object.entries(parsed.overrides).map(([key, text]) => [key, typeof text === "string" ? text.replace(/^votre enfant(?=\s)/i, "{enfant}") : text]))
          : {},
      promptOverrides:
        parsed?.promptOverrides && typeof parsed.promptOverrides === "object"
          ? parsed.promptOverrides
          : {},
      integrations: Array.isArray(parsed?.integrations) ? parsed.integrations : [],
      comments:
        parsed?.comments && typeof parsed.comments === "object" ? parsed.comments : {},
    });
  } catch {
    return emptyRevisions();
  }
}

export function saveRevisions(state) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // The in-memory copy still applies for this visit.
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("sp-lab-revisions", { detail: state }));
  }
}
